import React from "react";
import { lazy } from "react";
const Vendor = lazy(() => import("../organization/Vendor"));


const masterRoutes = [

    {
        path: "/master/vendor",
        element: <Vendor />
    },




];

export default masterRoutes;